import { render, staticRenderFns } from "./TaxDeductionPage.vue?vue&type=template&id=3faf1834&scoped=true"
import script from "./TaxDeductionPage.vue?vue&type=script&lang=js"
export * from "./TaxDeductionPage.vue?vue&type=script&lang=js"
import style0 from "./TaxDeductionPage.vue?vue&type=style&index=0&id=3faf1834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf1834",
  null
  
)

export default component.exports